/** Sample shapes and data — mirrors git/truth-first-look/src/pages/Dashboard.tsx */

export type LovableMediaType = 'image' | 'video';

export interface LovableMediaItem {
    type: LovableMediaType;
    url: string;
    thumbnail?: string;
}

export interface LovableQuotedPost {
    displayName: string;
    handle: string;
    avatarUrl: string;
    text: string;
    date: string;
    media?: LovableMediaItem[];
}

export interface LovablePost {
    avatarUrl: string;
    displayName: string;
    handle: string;
    date: string;
    text: string;
    isOwner?: boolean;
    commentCount?: number;
    repostCount?: number;
    likeCount?: number;
    scoreCount?: number;
    quotedPost?: LovableQuotedPost;
    isRepost?: boolean;
    repostedBy?: string;
    media?: LovableMediaItem[];
    liked?: boolean;
    reposted?: boolean;
    scored?: boolean;
}

export interface LovableSuggestedUser {
    name: string;
    handle: string;
    avatarUrl: string;
}

export interface LovableTrendingTopic {
    tag: string;
    postCount: number;
}

export const LOVABLE_SAMPLE_POSTS: LovablePost[] = [
    {
        avatarUrl: 'https://truthshorts.com/api/content/logo?userID=1',
        displayName: 'Truth Shorts',
        handle: 'truthshorts',
        date: 'Mar 11',
        text: 'Quote of quote of test quote',
        isOwner: true,
        commentCount: 0,
        repostCount: 0,
        likeCount: 0,
        scoreCount: 2,
        quotedPost: {
            displayName: 'Truth Shorts',
            handle: 'truthshorts',
            avatarUrl: 'https://truthshorts.com/api/content/logo?userID=1',
            text: 'Quote of Test Quote',
            date: 'Mar 11',
        },
    },
    {
        avatarUrl: 'https://truthshorts.com/api/content/logo?userID=1',
        displayName: 'Truth Shorts',
        handle: 'truthshorts',
        date: 'Mar 11',
        text: 'Quote of Test Quote',
        isOwner: true,
        commentCount: 0,
        repostCount: 0,
        likeCount: 0,
        scoreCount: 0,
        quotedPost: {
            displayName: 'Truth Shorts',
            handle: 'truthshorts',
            avatarUrl: 'https://truthshorts.com/api/content/logo?userID=1',
            text: 'Test Quote',
            date: 'Mar 11',
            media: [
                {
                    type: 'image',
                    url: 'https://media.tenor.com/9yFFB7RnEOcAAAAN/stasis-stasisnetwork.png',
                },
            ],
        },
    },
    {
        avatarUrl: 'https://i.pravatar.cc/40?img=5',
        displayName: 'Test Acct',
        handle: 'test_acct',
        date: 'Mar 7',
        text: 'Test #Multi 1/31/25',
        isRepost: true,
        repostedBy: 'Truth Shorts',
        isOwner: false,
        commentCount: 0,
        repostCount: 1,
        likeCount: 0,
        scoreCount: 0,
        reposted: true,
        media: [
            {
                type: 'video',
                url: 'https://media.tenor.com/Ti5zsAZb9C4AAAAN/trump-you-know-it.png',
                thumbnail: 'https://media.tenor.com/Ti5zsAZb9C4AAAAN/trump-you-know-it.png',
            },
            {
                type: 'image',
                url: 'https://media.tenor.com/Ti5zsAZb9C4AAAAN/trump-you-know-it.png',
            },
            {
                type: 'image',
                url: 'https://media.tenor.com/DzkF_PlRvvkAAAAN/preach-truth.png',
            },
        ],
    },
    {
        avatarUrl: 'https://truthshorts.com/api/content/logo?userID=1',
        displayName: 'Truth Shorts',
        handle: 'truthshorts',
        date: 'Mar 4',
        text: 'Test Post 030425',
        isOwner: true,
        commentCount: 0,
        repostCount: 0,
        likeCount: 0,
        scoreCount: 0,
        media: [
            {
                type: 'image',
                url: 'https://truthshorts.com/api/content/media?fileName=John316_Va_20250304204746805_b2436e15-d5c4-49d6-8b6b-63604af9ee91.jpg&mimeType=image/jpeg&userID=1',
            },
            {
                type: 'image',
                url: 'https://media.tenor.com/tMiT1u-WrqsAAAAN/lina-esco-swat.png',
            },
        ],
    },
    {
        avatarUrl: 'https://truthshorts.com/api/content/logo?userID=1',
        displayName: 'Truth Shorts',
        handle: 'truthshorts',
        date: 'Feb 28',
        text: 'Test Post Modal 022825',
        isOwner: true,
        commentCount: 0,
        repostCount: 0,
        likeCount: 0,
        scoreCount: 0,
        media: [
            { type: 'image', url: 'https://media.tenor.com/fXdH0oKT2psAAAAN/swat.png' },
            {
                type: 'image',
                url: 'https://truthshorts.com/api/content/media?fileName=John316_Va_20250301025335342_1c26ba5d-36c7-4b38-8bff-321fcf4b917d.jpg&mimeType=image/jpeg&userID=1',
            },
            { type: 'image', url: 'https://media.tenor.com/fXdH0oKT2psAAAAN/swat.png' },
            {
                type: 'image',
                url: 'https://truthshorts.com/api/content/media?fileName=John316_Va_20250301025335342_1c26ba5d-36c7-4b38-8bff-321fcf4b917d.jpg&mimeType=image/jpeg&userID=1',
            },
        ],
    },
    {
        avatarUrl: 'https://truthshorts.com/api/content/logo?userID=1',
        displayName: 'Truth Shorts',
        handle: 'truthshorts',
        date: 'Feb 28',
        text: 'Test post 022825',
        isOwner: true,
        commentCount: 0,
        repostCount: 0,
        likeCount: 0,
        scoreCount: 0,
        media: [
            { type: 'image', url: 'https://media.tenor.com/1uvcGR5HgOQAAAAN/you-have-to-try-ellen-gallagher.png' },
            {
                type: 'image',
                url: 'https://truthshorts.com/api/content/media?fileName=John316_Va_20250301025113390_7e51c7d3-43bd-41cd-aa1f-fa9e7d81d344.jpg&mimeType=image/jpeg&userID=1',
            },
        ],
    },
    {
        avatarUrl: 'https://truthshorts.com/api/content/logo?userID=1',
        displayName: 'Truth Shorts',
        handle: 'truthshorts',
        date: 'Feb 27',
        text: 'Test post 022725',
        isOwner: true,
        commentCount: 0,
        repostCount: 0,
        likeCount: 0,
        scoreCount: 0,
        media: [
            { type: 'image', url: 'https://media.tenor.com/oR79MxvajxUAAAAN/yuru-camp-laid-back-camp.png' },
            {
                type: 'video',
                url: 'https://media.tenor.com/oR79MxvajxUAAAAN/yuru-camp-laid-back-camp.png',
                thumbnail: 'https://media.tenor.com/oR79MxvajxUAAAAN/yuru-camp-laid-back-camp.png',
            },
        ],
    },
    {
        avatarUrl: 'https://truthshorts.com/api/content/logo?userID=1',
        displayName: 'Truth Shorts',
        handle: 'truthshorts',
        date: 'Feb 19',
        text: 'Test Post 021925',
        isOwner: true,
        commentCount: 0,
        repostCount: 0,
        likeCount: 1,
        scoreCount: 3,
        media: [
            { type: 'image', url: 'https://media.tenor.com/xguiUnpy1FYAAAAN/mister-bean-misterbean.png' },
            { type: 'image', url: 'https://media.tenor.com/sq9YDOeaVV0AAAAN/toby-cry-phone-spider-man-cry-phone.png' },
            {
                type: 'video',
                url: 'https://media.tenor.com/xguiUnpy1FYAAAAN/mister-bean-misterbean.png',
                thumbnail: 'https://media.tenor.com/xguiUnpy1FYAAAAN/mister-bean-misterbean.png',
            },
        ],
    },
    {
        avatarUrl: 'https://truthshorts.com/api/content/logo?userID=1',
        displayName: 'Truth Shorts',
        handle: 'truthshorts',
        date: 'Jan 31',
        text: 'Test Post from Modal',
        isOwner: true,
        commentCount: 0,
        repostCount: 0,
        likeCount: 0,
        scoreCount: 0,
        media: [{ type: 'image', url: 'https://media.tenor.com/kAxWVjQtNQMAAAAN/test.png' }],
    },
    {
        avatarUrl: 'https://truthshorts.com/api/content/logo?userID=1',
        displayName: 'Truth Shorts',
        handle: 'truthshorts',
        date: 'Jan 14',
        text: 'Test Post with Tenor Gif',
        isOwner: true,
        commentCount: 0,
        repostCount: 0,
        likeCount: 0,
        scoreCount: 0,
        media: [{ type: 'image', url: 'https://media.tenor.com/LsCN-4zGKikAAAAN/test-singing.png' }],
    },
];

export const LOVABLE_SUGGESTED_USERS: LovableSuggestedUser[] = [
    { name: 'realCharlieKirk', handle: 'realCharlieKirk_', avatarUrl: 'https://i.pravatar.cc/40?img=11' },
    { name: 'jasonwhitlock', handle: 'jasonwhitlock_j', avatarUrl: 'https://i.pravatar.cc/40?img=12' },
    { name: 'target', handle: 'target_acct', avatarUrl: 'https://i.pravatar.cc/40?img=13' },
    { name: 'nike', handle: 'nike_acct', avatarUrl: 'https://i.pravatar.cc/40?img=14' },
    { name: 'youtube', handle: 'youtube_acct', avatarUrl: 'https://i.pravatar.cc/40?img=15' },
    { name: 'TulsiGabbard', handle: 'tulsi_gabbard_o', avatarUrl: 'https://i.pravatar.cc/40?img=16' },
];

export const LOVABLE_TRENDING_TOPICS: LovableTrendingTopic[] = [
    { tag: '#ufcmacau', postCount: 1240 },
    { tag: '#multi', postCount: 890 },
    { tag: '#ufc309', postCount: 2100 },
    { tag: '#thehairtales', postCount: 560 },
    { tag: '#solarmentepartner', postCount: 340 },
];
